// src/modules/module_appbar.tsx
import * as React from 'react';
import {
  AppBar,
  AppBarSection,
  AppBarSpacer,
  Avatar,
} from '@progress/kendo-react-layout';
import { Badge, BadgeContainer } from '@progress/kendo-react-indicators';
import { Button } from '@progress/kendo-react-buttons';
import logo from '../images/exploserv-logo-200x72.png'; // Pfad zum Logo importieren
import ProfilePicture from '../images/exploserv_profile_placeholder.png'; // Pfad zum Logo importieren
import { useAuth } from '../contexts/AuthContext'; // Import the useAuth hook
import { useNavigate } from 'react-router-dom'; // Import useNavigate for redirection
import { bellIcon, menuIcon, logoutIcon } from '@progress/kendo-svg-icons';

// let kendokaAvatar = 'https://www.telerik.com/kendo-react-ui-develop/components/images/kendoka-react.png';

const ModuleAppBar: React.FC = () => {
  const { userId, setUserId } = useAuth(); // Get the userId and setUserId from the context
  const navigate = useNavigate(); // Use the useNavigate hook for redirection

  // Redirect to login if the user is not logged in
  React.useEffect(() => {
    if (!userId) {
      navigate('/login', { replace: true }); // Redirect to the login page
    }
  }, [userId, navigate]);

  // Logout function
  const handleLogout = () => {
    setUserId(null); // Reset the userId in the context
    navigate('/login', { replace: true }); // Redirect to the login page
  };

  return (
    <React.Fragment>
      <AppBar themeColor="inherit" style={{ backgroundColor: '#fff' }}>
        <AppBarSection>
          <Button type="button" fillMode="flat" svgIcon={menuIcon} />
        </AppBarSection>
        <AppBarSpacer style={{ width: 4 }} />
        <AppBarSection>
          <img src={logo} alt="EXPLOSERV Logo" className="appbar-logo" />
        </AppBarSection>
        <AppBarSpacer style={{ width: 5 }} />
        <AppBarSection>
          <ul className="appbar-menu">
            <li>
              <span>&nbsp;</span>
            </li>
            <li>
              <span>&nbsp;</span>
            </li>
            <li>
              <span>&nbsp;</span>
            </li>
          </ul>
        </AppBarSection>
        <AppBarSpacer />
        <AppBarSection className="appbar-actions">
          {/* Logout Button */}
          <Button
            type="button"
            fillMode="flat"
            svgIcon={logoutIcon}
            onClick={handleLogout} // Attach the logout function to the button
          >
            Abmelden
          </Button>
        </AppBarSection>
        <AppBarSection>
          <span className="k-appbar-separator" />
        </AppBarSection>
        <AppBarSection>
          <Avatar type="image">
            <img src={ProfilePicture} alt="Exploserv GmbH Placeholder Picture" />
          </Avatar>
        </AppBarSection>
      </AppBar>
      <style>{`
        .appbar-logo {
          height: 50px; /* Höhe des Bildes auf 50px setzen */
        }

        .appbar-menu {
          font-size: 14px;
          list-style-type: none;
          padding: 0;
          margin: 0;
          display: flex;
        }

        .appbar-menu li {
          margin: 0 0px;
        }

        .appbar-menu li:hover {
          cursor: pointer;
          color: #84cef1;
        }

        .appbar-actions .k-badge-container {
          margin-right: 8px;
        }
      `}</style>
    </React.Fragment>
  );
};

export default ModuleAppBar;